<template>
  <accordion-section
    :open="section === 4"
    :valid="!!primaryPhone"
    @selected="$emit('openSection', 4)"
  >
    <template #heading>
      Business Phone
    </template>

    <custom-input
      v-model="primaryPhone"
      label="Primary phone number"
      :disabled="!canEditLocation"
    />

    <custom-input
      v-for="(number, index) in additionalPhones"
      :key="index"
      :label="index === 0 ? 'Additional phone numbers' : null"
      :placeholder="`Additional phone number ${index+1}`"
      :value="additionalPhones[index]"
      :disabled="!canEditLocation"
      @input="updateAdditionalPhoneByIndex({value: $event.target.value, index})"
    />

    <div
      v-if="lastAdditionalPhoneHasValue && canEditLocation"
      class="addLine"
    >
      <button
        class="addLineBtn"
        @click="addAdditionalPhone(additionalPhones)"
      >
        + Add an additional phone number
      </button>
    </div>

    <div class="recommendations">
      <span>Recommendations</span>

      <p class="sub">
        If you use a call tracking number for your Google Business Profile listing:
      </p>
      <ul>
        <li>Use the call tracking number in the “Primary Phone” field.</li>
        <li>Add your primary, local phone number as an “Additional Phone”.</li>
        <li>Add toll-free and secondary phone numbers as “Additional Phone” fields.</li>
      </ul>

      <p class="sub">
        If you do NOT use a call tracking number for your Google Business Profile listing:
      </p>
      <ul>
        <li>Use your primary, local phone number in the “Primary Phone” field.</li>
        <li>Add toll-free and secondary phone numbers as “Additional Phone” fields.</li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import AccordionSection from "../items/AccordionSection";
import {mapActions, mapGetters, mapMutations} from "vuex";
import CustomInput from "../../../../../views/reports/components/global/forms/CustomInput";

export default {
  components: {
    CustomInput,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'location',
      'additionalPhones'
    ]),
    primaryPhone: {
      get() {
        return this.$store.getters["businessProfile/primaryPhone"];
      },
      set(primaryPhone) {
        if (this.location) {
          this.updatePrimaryPhone(primaryPhone);
        }
      }
    },
    lastAdditionalPhoneHasValue() {
      if (this.additionalPhones) {
        let lastIndex = this.additionalPhones.length - 1;
        return this.additionalPhones[lastIndex] !== '';
      }
      return true;
    },
  },
  methods: {
    ...mapMutations('editListing', [
      'setSelectedSection',
    ]),
    ...mapActions('businessProfile', [
      'updatePrimaryPhone',
      'updateAdditionalPhoneByIndex',
      'addAdditionalPhone'
    ]),
  },
}
</script>

<style lang="scss" scoped>
.addLine {
  width: 100%;
  margin-top: -1rem;
  margin-bottom: .5rem;

  .addLineBtn {
    color: #37B2A8;

    &:hover {
      color: #0A8080;
      text-decoration: underline;
    }
  }
}
</style>
